import { ShoppingBag, Zap } from "lucide-react";
import { useLang } from "@/lib/i18n";

const Line = ({ label, value, testid, strong }) => (
  <div className={`flex justify-between py-1.5 text-sm ${strong ? "font-extrabold text-white" : "text-slate-300"}`}>
    <span>{label}</span>
    <span className="font-mono-num" data-testid={testid}>{value}</span>
  </div>
);

export const PricePanel = ({ line, quote, type, canAdd, onAdd, hint }) => {
  const { t, money, num } = useLang();
  return (
    <aside className="panel sticky top-24 overflow-hidden" data-testid="price-panel">
      <div className={`h-1.5 ${type === "dtf" ? "bg-ruby" : "bg-cap"}`} />
      <div className="p-6">
        <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-slate-400">{t("builder.summary")}</p>
        <p className="mt-2 font-display text-5xl text-gold" data-testid="line-total">{money(line?.line_total || 0)}</p>
        {line && <p className="mt-1 text-sm text-slate-400" data-testid="per-piece">{t("builder.per_piece", { p: money(line.unit_price, 3) })}</p>}
        <div className="mt-6 border-t border-white/10 pt-4">
          <Line label={t("builder.area")} value={`${num(line?.area_each || 0)} in²`} testid="area-each" />
          <Line label={t("builder.total_area")} value={`${num(line?.total_area || 0)} in²`} testid="total-area" />
          <Line label={t("builder.rate")} value={`${money(line?.rate || 0, 3)} / in²`} testid="rate" />
          <Line label={<span className="inline-flex items-center gap-1">{t("builder.print")} {line?.rush && <Zap className="h-3.5 w-3.5 text-gold" />}</span>} value={money(line?.print_cost || 0)} testid="print-cost" />
          <Line label={t("builder.extras")} value={money(line?.extras_cost || 0)} testid="extras-cost" />
          <Line label={t("builder.setup")} value={money(line?.setup_fee || 0)} testid="setup-fee" />
          <div className="mt-2 border-t border-white/10 pt-2">
            <Line label={t("builder.line_total")} value={money(line?.line_total || 0)} strong testid="line-total-row" />
          </div>
        </div>
        {type === "dtf" && quote && <p className="mt-3 text-xs text-slate-500" data-testid="tier-note">{t("builder.tier_note", { area: num(quote.dtf_area, 1) })}</p>}
        {line?.rush && <p className="mt-2 text-xs text-amber-300">{t("builder.rush_cutoff")}</p>}
        <button type="button" onClick={onAdd} disabled={!canAdd} className="btn-gold mt-6 w-full" data-testid="add-to-cart-btn">
          <ShoppingBag className="h-4 w-4" /> {t("builder.add")}
        </button>
        {hint && <p className="mt-3 text-center text-xs font-semibold text-slate-400" data-testid="add-hint">{hint}</p>}
      </div>
    </aside>
  );
};
